import {HttpClient, HttpParams} from '@angular/common/http';
import {ConfigService} from './config.service';
import {Injectable} from '@angular/core';

@Injectable()
export class LenderEventsService {
    private httpClient: HttpClient;

    constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    public async lenderCreationEvent(inviteId: string, userId: string): Promise<void> {
        const url = ConfigService.getBaseUrl() + '/lender-events/creation';
        const params = new HttpParams().set('userId', userId).set('inviteId', inviteId);
        await this.httpClient.post(url, {}, {params: params}).toPromise();
    }
}

